import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  TICKET_FEATURE_KEY,
} from './ticket.reducer';
import { ITicketState } from './ticket.models';
import { ICounterModel, TError } from '@amwager/util-ts';

// Lookup the 'Ticket' feature state managed by NgRx
export const selectTicketState =
  createFeatureSelector<ITicketState>(TICKET_FEATURE_KEY);

export const getTicketLoaded = createSelector(
  selectTicketState,
  (state: ITicketState): boolean | undefined => state?.isLoaded
);

export const getTicketError = createSelector(
  selectTicketState,
  (state: ITicketState): TError => state?.error
);

export const getCounters = createSelector(
  selectTicketState,
  (state: ITicketState): ICounterModel | undefined => state?.counters?.response?.Counter
);
